var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-primary mb-4",attrs:{"role":"button","to":{name: 'administration.channels.new'}}},[_c('icon',{staticClass:"btn-icon",attrs:{"name":"plus-circle"}}),_vm._v("\n  Add New Channel\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }